import { Component } from '@angular/core';

@Component({
  selector: 'app-results-empty-facet',
  templateUrl: './results-empty-facet.component.html',
  styleUrls: ['./results-empty-facet.component.css']
})
export class ResultsEmptyFacetComponent {

}
